<template>
    <div class="popup-response replay-error-popup popup-all" style="display: block" >
            <div class="popup-container">
                <div class="popup-vue has-header">
                    <div class="popup-header">
                        <img class="popup-logo" src="/img/credit-landing-vue/popup-logo.svg">
                        <div class="popup-tel" v-html="__t('Телефон попап потор номера')"></div>
                    </div>
                    <div class="popup-content-on-mob">

                        <div class="popup-img">
                            <img src="/img/credit-landing-vue/response-error.svg" alt="error">
                        </div>

                        <div class="popup-description">
                            <p v-html="__t('Ви вже надсилали заявку на оформлення кредиту з даного номеру телефону.')"></p>
                        </div>


                        <div class="button-wrapper page-bottom ">
                            <a id="closePopupFocusId" tabindex="0" class="single-button btn violet-btn" @click="popupClose()" @keydown.enter.prevent="popupClose()">{{__t('Закрити')}}</a>
                        </div>

                    </div>
                </div>
            </div>
    </div>
</template>

<script>

    export default {
        name: 'popup-error',
        props: [],
        data() {
            return {

            }
        },
        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            popupClose: function() {
                this.$emit('popupReplayErrorHide')
            }
        }
    }

</script>